import type React from 'react'

import { FieldType } from '@/shared/generated'

import { BasicBadgeField } from './BasicBadgeField'
import { BasicCheckboxEditorField } from './BasicCheckboxEditorField'
import { BasicCheckboxField } from './BasicCheckboxField'
import { BasicChipField } from './BasicChipField'
import { BasicChoiceField } from './BasicChoiceField'
import { BasicCountField } from './BasicCountField'
import { BasicCurrencyEditorField } from './BasicCurrencyEditorField'
import { BasicCurrencyField } from './BasicCurrencyField'
import { BasicDateField } from './BasicDateField'
import { BasicDatetimeDistanceField } from './BasicDatetimeDistanceField'
import { BasicDeltaField } from './BasicDeltaField'
import { BasicFlagField } from './BasicFlagField'
import { BasicImageField } from './BasicImageField'
import { BasicLockEditableField } from './BasicLockEditableField'
import { BasicLockField } from './BasicLockField'
import { BasicNumberEditorField } from './BasicNumberEditorField'
import { BasicNumberField } from './BasicNumberField'
import { BasicPercentField } from './BasicPercentField'
import { BasicPriceEditorField } from './BasicPriceEditorField'
import { BasicPriceField } from './BasicPriceField'
import { BasicSelectEditorField } from './BasicSelectEditorField'
import { BasicTextEditorField } from './BasicTextEditorField'
import { BasicTextField } from './BasicTextField'
import { BasicTreeField } from './BasicTreeField'
import { BasicUrlField } from './BasicUrlField'

export const fields = {
	[FieldType.Url]: {
		type: FieldType.Url,
		cellComponent: BasicUrlField,
		cellEditorComponent: BasicTextEditorField,
	},
	[FieldType.Count]: {
		type: FieldType.Count,
		cellComponent: BasicCountField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Number]: {
		type: FieldType.Number,
		cellComponent: BasicNumberField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Currency]: {
		type: FieldType.Currency,
		cellComponent: BasicCurrencyField,
		cellEditorComponent: BasicCurrencyEditorField,
	},
	[FieldType.Lock]: {
		type: FieldType.Lock,
		cellComponent: BasicLockField,
		cellEditorComponent: BasicLockEditableField,
	},
	[FieldType.Price]: {
		type: FieldType.Price,
		cellComponent: BasicPriceField,
		cellEditorComponent: BasicPriceEditorField,
	},
	[FieldType.Percent]: {
		type: FieldType.Percent,
		cellComponent: BasicPercentField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Text]: {
		type: FieldType.Text,
		cellComponent: BasicTextField,
		cellEditorComponent: BasicTextEditorField,
	},
	[FieldType.Delta]: {
		type: FieldType.Delta,
		cellComponent: BasicDeltaField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Badge]: {
		type: FieldType.Badge,
		cellComponent: BasicBadgeField,
		cellEditorComponent: BasicSelectEditorField,
	},
	[FieldType.Chip]: {
		type: FieldType.Chip,
		cellComponent: BasicChipField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Choice]: {
		type: FieldType.Choice,
		cellComponent: BasicChoiceField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Flag]: {
		type: FieldType.Flag,
		cellComponent: BasicFlagField,
		cellEditorComponent: BasicCheckboxEditorField,
	},
	[FieldType.Checkbox]: {
		type: FieldType.Checkbox,
		cellComponent: BasicCheckboxField,
		cellEditorComponent: BasicCheckboxEditorField,
	},
	[FieldType.Image]: {
		type: FieldType.Image,
		cellComponent: BasicImageField,
		cellEditorComponent: BasicTextEditorField,
	},
	[FieldType.DateDistanceAt]: {
		type: FieldType.DateDistanceAt,
		cellComponent: BasicDatetimeDistanceField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Datetime]: {
		type: FieldType.Datetime,
		cellComponent: BasicDatetimeDistanceField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Date]: {
		type: FieldType.Date,
		cellComponent: BasicDateField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Tree]: {
		type: FieldType.Tree,
		cellComponent: BasicTreeField,
		cellEditorComponent: BasicNumberEditorField,
	},
	[FieldType.Custom]: {
		type: FieldType.Custom,
		cellComponent: BasicTextField,
		cellEditorComponent: BasicTextEditorField,
	},
}

export type FieldsRegistry = typeof fields
export type FieldCellProps<K extends FieldType> = K extends keyof FieldsRegistry
	? React.ComponentProps<FieldsRegistry[K]['cellComponent']>
	: never
export type FieldCellEditorProps<K extends FieldType> =
	K extends keyof FieldsRegistry
		? React.ComponentProps<FieldsRegistry[K]['cellEditorComponent']>
		: never
